import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
//
import { dispatch } from '../store';

// ----------------------------------------------------------------------

const initialState = {
  isCompanyLoading: false,
  isUserCompanyLoading: false,
  isCompanyEmployeeLoading: false,
  isCompanyUserLoading: false,
  isCompanyStatuseLoading: false,
  isDepartmentLoading: false,
  isManufacturerLoading: false,
  isUOMLoading: false,
  isAttachmentTypeLoading: false,
  isAttachmentExtensionTypeLoading: false,
  isAttachmentStatusLoading: false,
  isAttachmentRevisionLoading: false,
  error: null,
  companies: null,
  userCompanies: null,
  company_employees: null,
  company_users: null,
  company_statuses: null,
  departments: null,
  manufacturers: null,
  unitOfMeasures: null,
  attachment_types: null,
  attachment_extension_types: null,
  attachment_revision: null,
  attachment_statuses: null,
};

const slice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    // START LOADING
    startCompanyLoading(state) {
      state.isCompanyLoading = true;
    },
    startAttachmentTypeLoading(state) {
      state.isAttachmentTypeLoading = true;
    },
    startAttachmentExtensionTypeLoading(state) {
      state.isAttachmentExtensionTypeLoading = true;
    },
    startAttachmentRevisionLoading(state) {
      state.isAttachmentRevisionLoading = true;
    },
    startAttachmentStatusLoading(state) {
      state.isAttachmentStatusLoading = true;
    },
    startUserCompanyLoading(state) {
      state.isUserCompanyLoading = true;
    },
    startCompanyEmployeeLoading(state) {
      state.isCompanyEmployeeLoading = true;
    },
    startCompanyUserLoading(state) {
      state.isCompanyUserLoading = true;
    },
    startCompanyStatuseLoading(state) {
      state.isCompanyStatuseLoading = true;
    },
    startDepartmentLoading(state) {
      state.isDepartmentLoading = true;
    },
    startManufacturerLoading(state) {
      state.isManufacturerLoading = true;
    },
    startUOMLoading(state) {
      state.isUOMLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isCompanyLoading = false;
      state.isCompanyEmployeeLoading = false;
      state.isCompanyUserLoading = false;
      state.isCompanyStatuseLoading = false;
      state.isDepartmentLoading = false;
      state.isManufacturerLoading = false;
      state.isAttachmentTypeLoading = false;
      state.isAttachmentExtensionTypeLoading = false;
      state.isAttachmentRevisionLoading = false;
      state.isAttachmentStatusLoading = false;
      state.error = action.payload;
    },
    // SET COMPANY
    setCompany(state, action) {
      state.isCompanyLoading = false;
      state.companies = action.payload;
    },
    // SET COMPANY
    setUserCompany(state, action) {
      state.isUserCompanyLoading = false;
      state.userCompanies = action.payload;
    },
    // SET COMPANY EMPLOYEE
    setCompanyEmployee(state, action) {
      state.isCompanyEmployeeLoading = false;
      state.company_employees = action.payload;
    },
    // SET COMPANY USER
    setCompanyUsers(state, action) {
      state.isCompanyUserLoading = false;
      state.company_users = action.payload;
    },
    // SET COMPANY STATUSES
    setCompanyStatuses(state, action) {
      state.isCompanyStatuseLoading = false;
      state.company_statuses = action.payload;
    },
    // SET DEPARTMENTS
    setDepartments(state, action) {
      state.isDepartmentLoading = false;
      state.departments = action.payload;
    },
    // SET MANUFACTURERS
    setManufacturers(state, action) {
      state.isManufacturerLoading = false;
      state.manufacturers = action.payload;
    },
    //SET UOM
    setUnitOfMeasures(state, action) {
      state.isUOMLoading = false;
      state.unitOfMeasures = action.payload;
    },
    //SET Attachment Type
    setAttachmentTypes(state, action) {
      state.isAttachmentTypeLoading = false;
      state.attachment_types = action.payload;
    },

    //SET Attachment Extension Type
    setAttachmentExtensionTypes(state, action) {
      state.isAttachmentExtensionTypeLoading = false;
      state.attachment_extension_types = action.payload;
    },

    //SET Attachment Revision
    setAttachmentRevision(state, action) {
      state.isAttachmentRevisionLoading = false;
      state.attachment_revision = action.payload;
    },

    //SET Attachment Type
    setAttachmentStatus(state, action) {
      state.isAttachmentStatusLoading = false;
      state.attachment_statuses = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startCompanyLoading,
  startCompanyEmployeeLoading,
  startCompanyUserLoading,
  startCompanyStatuseLoading,
  startDepartmentLoading,
  startManufacturerLoading,
  startModuleLoading,
  startAttachmentTypeLoading,
  startAttachmentExtensionTypeLoading,
  startAttachmentRevisionLoading,
  startAttachmentStatusLoading,
  hasError,
} = slice.actions;

// ----------------------------------------------------------------------

export function getCompany() {
  return async () => {
    dispatch(slice.actions.startCompanyLoading());
    try {
      const response = await axios.get('/admin/company/companies');
      dispatch(slice.actions.setCompany(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUserCompany() {
  return async () => {
    dispatch(slice.actions.startUserCompanyLoading());
    try {
      const response = await axios.get('/dropdown/company/companies');
      dispatch(slice.actions.setUserCompany(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompanyEmployee(fetchUrl = '/admin/company/company_employees', params = {}) {
  return async () => {
    dispatch(slice.actions.startCompanyEmployeeLoading());
    try {
      const response = await axios.get(fetchUrl, {
        params: params,
      });
      dispatch(slice.actions.setCompanyEmployee(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompanyDrivers(fetchUrl = '/admin/ticket/drivers', params = {}) {
  return async () => {
    dispatch(slice.actions.startCompanyEmployeeLoading());
    try {
      const response = await axios.get(fetchUrl, {
        params: params,
      });
      dispatch(slice.actions.setCompanyEmployee(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompanyStatuses() {
  return async () => {
    dispatch(slice.actions.startCompanyStatuseLoading());
    try {
      const response = await axios.get('/admin/company/company_statuses');
      dispatch(slice.actions.setCompanyStatuses(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getDepartments(companyId) {
  return async () => {
    dispatch(slice.actions.startDepartmentLoading());
    try {
      const response = await axios.get('/admin/company/departments', {
        params: {
          company_id: companyId,
        },
      });
      dispatch(slice.actions.setDepartments(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getManufacturer(companyId) {
  return async () => {
    dispatch(slice.actions.startManufacturerLoading());
    try {
      const response = await axios.get('/admin/company/manufacturers', {
        params: {
          company_id: companyId,
        },
      });
      dispatch(slice.actions.setManufacturers(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompanyEmployees() {
  return async () => {
    dispatch(slice.actions.startCompanyEmployeeLoading());
    try {
      const response = await axios.get('/admin/company/get/company_employees');
      dispatch(slice.actions.setCompanyEmployee(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getCompanyUsers() {
  return async () => {
    dispatch(slice.actions.startCompanyUserLoading());
    try {
      const response = await axios.get('/admin/company/get/company_users');
      dispatch(slice.actions.setCompanyUsers(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUsers(companyId) {
  return async () => {
    dispatch(slice.actions.startCompanyUserLoading());
    try {
      const response = await axios.get('/admin/user/users', {
        params: {
          company_id: companyId,
        },
      });
      dispatch(slice.actions.setCompanyUsers(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getUnitOfMeasures() {
  return async () => {
    dispatch(slice.actions.startUOMLoading());
    try {
      const response = await axios.get('/admin/company/unit_measurements');
      dispatch(slice.actions.setUnitOfMeasures(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAttachmentTypes() {
  return async () => {
    dispatch(slice.actions.startAttachmentTypeLoading());
    try {
      const response = await axios.get('/dropdown/company/attachment/attachment_types');
      dispatch(slice.actions.setAttachmentTypes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAttachmentExtensionTypes() {
  return async () => {
    dispatch(slice.actions.startAttachmentExtensionTypeLoading());
    try {
      const response = await axios.get('/dropdown/company/attachment/attachment_extension_types');
      dispatch(slice.actions.setAttachmentExtensionTypes(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAttachmentRevision() {
  return async () => {
    dispatch(slice.actions.startAttachmentRevisionLoading());
    try {
      const response = await axios.get('/dropdown/company/attachment/attachment_revision');
      dispatch(slice.actions.setAttachmentRevision(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getAttachmentStatus() {
  return async () => {
    dispatch(slice.actions.startAttachmentStatusLoading());
    try {
      const response = await axios.get('/dropdown/company/attachment/attachment_status');
      dispatch(slice.actions.setAttachmentStatus(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
